<template>
  <div class="wap-discuss">
    <img
      src="../../assets/images/top.png"
      class="top"
      alt=""
      v-if="interaction.topList.length > 0"
      @click="showTop(true)"
    />
    <ul class="discuss-header">
      <li
        :class="{
          active: type == '1',
          'new-message': interaction.unReadCount > 0
        }"
        @click="changeDiscussType('1')"
      >
        互动问答
      </li>
      <li
        :class="{
          active: type == '2',
          'new-message': mine.unReadCount > 0
        }"
        @click="changeDiscussType('2')"
      >
        我的提问
      </li>
      <li
        :class="{
          active: type == '3',
          'new-message': conversation.unReadCount > 0
        }"
        @click="changeDiscussType('3')"
      >
        我的私聊
      </li>
    </ul>
    <div class="top-qa" v-show="isShowTop && interaction.topList.length > 0">
      <span class="icontemp clear" @click="showTop(false)"></span>
      <div
        class="content-item"
        v-for="(item, i) in interaction.topList"
        :key="i"
      >
        <div class="admin-reply">
          <div class="reply-head">
            <div class="head">
              <span
                class="icon icontemp admin administrator"
                v-if="item.from_user.avatar == '' || !item.from_user.avatar"
              ></span>
              <img
                :src="item.from_user.avatar"
                alt=""
                v-if="item.from_user.avatar && item.from_user.avatar != ''"
              />
            </div>
            <div class="reply" :style="{ flex: item.to_user ? 'unset' : '1' }">
              {{ item.from_user.userName }}{{ item.to_user ? "回复了" : "" }}
            </div>
            <div class="name" v-if="item.to_user">
              {{
                userInfo.applicantId == item.to_user.uid
                  ? "我"
                  : item.to_user.userName
              }}
            </div>
            <img src="../../assets/images/top.png" class="top in" alt="" />
            <div class="r-time">{{ item.updated_at }}</div>
          </div>
          <div class="reply-content" v-html="replaceColon(item.content)"></div>
        </div>
      </div>
    </div>
    <div class="discuss-content" id="wapinteraction" v-if="type == '1'">
      <div v-if="interaction.list.length > 0" style="min-height: 100%">
        <div
          class="content-item"
          v-for="(item, i) in interaction.list"
          :key="i"
        >
          <div
            v-if="
              (item.from_user.role == '0' || item.from_user.role == '1') &&
                item.refList.length == 0
            "
          >
            <div class="item-title">
              <div class="head">
                <img :src="item.from_user.avatar" alt="" />
              </div>
              <div class="name">
                {{
                  userInfo.applicantId == item.from_user.uid
                    ? "我"
                    : item.from_user.userName
                }}
              </div>
              <div class="d-time">{{ item.updated_at }}</div>
            </div>
            <div class="content" v-html="replaceColon(item.content)"></div>
          </div>

          <div v-if="item.refList.length > 0">
            <div class="admin-reply" v-for="(list, j) in item.refList" :key="j">
              <div
                v-if="item.from_user.role == '2' || item.from_user.role == '1'"
              >
                <div class="reply-head">
                  <div class="head">
                    <span
                      class="icon icontemp admin administrator"
                      v-if="
                        item.from_user.avatar == '' || !item.from_user.avatar
                      "
                    ></span>
                    <img
                      :src="item.from_user.avatar"
                      alt=""
                      v-if="
                        item.from_user.avatar && item.from_user.avatar != ''
                      "
                    />
                  </div>
                  <div class="reply">{{ item.from_user.userName }}回复了</div>
                  <div class="name">
                    {{
                      userInfo.applicantId == item.to_user.uid
                        ? "我"
                        : item.to_user.userName
                    }}
                  </div>
                  <div class="r-time">{{ list.updated_at }}</div>
                </div>
                <div
                  class="reply-content"
                  v-html="replaceColon(item.content)"
                ></div>
              </div>
            </div>
          </div>
          <div v-if="item.refList.length == 0 && item.from_user.role == '2'">
            <div class="admin-reply">
              <div class="reply-head">
                <div class="head">
                  <span
                    class="icon icontemp admin administrator"
                    v-if="item.from_user.avatar == '' || !item.from_user.avatar"
                  ></span>
                  <img
                    :src="item.from_user.avatar"
                    alt=""
                    v-if="item.from_user.avatar && item.from_user.avatar != ''"
                  />
                </div>
                <div
                  class="reply"
                  :style="{ flex: item.to_user ? 'unset' : '1' }"
                >
                  {{ item.from_user.userName
                  }}{{ item.to_user ? "回复了" : "" }}
                </div>
                <div class="name" v-if="item.to_user">
                  {{
                    userInfo.applicantId == item.to_user.uid
                      ? "我"
                      : item.to_user.userName
                  }}
                </div>
                <div class="r-time">{{ item.updated_at }}</div>
              </div>
              <div
                class="reply-content"
                v-html="replaceColon(item.content)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item center" v-if="interaction.list.length == '0'">
        <img :src="noQA" />
        <p class="noQA-tips">暂无问答</p>
      </div>
    </div>
    <div class="discuss-content" id="wapmine" v-if="type == '2'">
      <div v-if="mine.list.length > 0">
        <div class="content-item" v-for="(item, i) in mine.list" :key="i">
          <div v-if="item.from_user.role == '0'">
            <div class="item-title">
              <div class="head">
                <img :src="item.from_user.avatar" alt="" />
              </div>
              <div class="name">
                {{
                  userInfo.applicantId == item.from_user.uid
                    ? "我"
                    : item.from_user.userName
                }}
              </div>
              <div class="d-time">{{ item.updated_at }}</div>
            </div>
            <div class="content" v-html="replaceColon(item.content)"></div>
          </div>
          <div v-if="item.from_user.role != '0'">
            <div class="admin-reply">
              <div
                v-if="item.from_user.role == '2' || item.from_user.role == '1'"
              >
                <div class="reply-head">
                  <div class="head">
                    <span
                      class="icon icontemp admin administrator"
                      v-if="
                        item.from_user.avatar == '' || !item.from_user.avatar
                      "
                    ></span>
                    <img
                      :src="item.from_user.avatar"
                      alt=""
                      v-if="
                        item.from_user.avatar && item.from_user.avatar != ''
                      "
                    />
                  </div>
                  <div class="reply">{{ item.from_user.userName }}回复了</div>
                  <div class="name">
                    {{
                      userInfo.applicantId == item.to_user.uid
                        ? "我"
                        : item.name
                    }}
                  </div>
                  <div class="r-time">{{ item.updated_at }}</div>
                </div>
                <div
                  class="reply-content"
                  v-html="replaceColon(item.content)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item center" v-if="mine.list.length == '0'">
        <img :src="noQA" />
        <p class="noQA-tips">暂无问答</p>
      </div>
    </div>
    <div class="discuss-content" v-if="type == '3'">
      <div v-if="conversation.type == '0'">
        <div v-if="conversation.list.length > 0">
          <div
            class="content-item"
            v-for="(option, n) in conversation.list"
            :key="n"
          >
            <div class="item-title">
              <div class="head">
                <!--<img :src="adminImg" alt="" />-->
                <span
                  class="icon icontemp admin administrator"
                  v-if="option.admin.avatar == '' || !option.admin.avatar"
                ></span>
                <img
                  :src="option.admin.avatar"
                  alt=""
                  v-if="option.admin.avatar && option.admin.avatar != ''"
                />
              </div>
              <div class="name">{{ option.admin.userName }}</div>
              <div class="d-time">{{ option.updated_at }}</div>
            </div>
            <div class="wap-speak-lists">
              <div
                class="content"
                @click="loadMessages(option)"
                v-html="replaceColon(option.chat.content)"
              ></div>
              <span class="count" v-if="option.unReadCount > 0">{{
                option.unReadCount
              }}</span>
            </div>
          </div>
        </div>
        <div class="content-item center" v-if="conversation.list.length == '0'">
          <img :src="noQA" />
          <p class="noQA-tips">暂无问答</p>
        </div>
      </div>
      <div v-if="conversation.type != '0'">
        <li class="conversationInfo">
          <span @click="backConversation" class="back">返回 </span>
          <span>{{ conversation.currentAdminInfo.adminName }}</span>
        </li>
        <div
          class="content-item"
          v-for="(option1, m) in conversation.currentConversation"
          :key="m"
        >
          <div class="item-title">
            <div class="head">
              <span
                class="icon icontemp admin administrator"
                v-if="
                  option1.from_user.avatar == '' || !option1.from_user.avatar
                "
              ></span>
              <img
                :src="option1.from_user.avatar"
                alt=""
                v-if="
                  option1.from_user.avatar && option1.from_user.avatar != ''
                "
              />
            </div>
            <div class="name">
              {{
                userInfo.uid == option1.from_user.uid
                  ? "我"
                  : option1.from_user.userName
              }}
            </div>
            <div class="d-time">{{ option1.updated_at }}</div>
          </div>
          <div class="content" v-html="replaceColon(option1.content)"></div>
        </div>
      </div>
    </div>
    <div class="discuss-box">
      <div class="discuss-input">
        <div class="input-group">
          <div
            class="edit-able"
            placeholder="说两句..."
            contenteditable="true"
          ></div>
          <span class="icon icontemp smiley" @click="emoji"></span>
          <div class="icon icontemp local-img tupian" @click="selectFile">
            <input
              v-show="false"
              type="file"
              ref="localImage"
              @change="fileChange($event)"
              accept="image/gif,image/jpeg,image/jpg,image/png"
            />
          </div>
        </div>
        <div class="submit-botton" @click="submit()">
          <span class="icon icontemp arrow-t"></span>
        </div>
      </div>
    </div>
    <Emoji ref="emoji" :isMobile="true" @change="getContent"></Emoji>
  </div>
</template>
<script>
import { $subscriber, ck, interact, cr } from "fire-wind-water";
import $ from "jquery";
import moment from "moment";
import { socketModule } from "../../common/socket";
import webinarService from "../../services/webinar";
import { symbolReg, replaceColon } from "../../common/emoji";
import Emoji from "./Emoji";

export default {
  name: "Discuss",
  data() {
    return {
      content: "",
      symbolReg: symbolReg,
      list: [{ content: "😵😵" }],
      type: "1",
      status: false,
      adminImg: require("../../assets/images/icon-moderator.png"),
      userImg: require("../../assets/images/d-defaut.png"),
      noQA: require("../../assets/images/noQA.png"),
      firstUpdatedAt: "",
      userInfo: {},
      webinarInfo: {},
      interaction: {
        pageSize: 50,
        list: [],
        topList: [],
        unReadCount: 0,
        firstUpdatedAt: "",
        allTotal: 0
      },
      mine: {
        pageSize: 50,
        list: [],
        unReadCount: 0,
        firstUpdatedAt: "",
        allTotal: 0
      },
      conversation: {
        pageSize: 50,
        list: [],
        unReadCount: 0,
        type: 0,
        currentConversation: [],
        firstUpdatedAt: "",
        allTotal: 0,
        currentAdminInfo: {
          adminName: "",
          id: ""
        }
      },
      topQa: {},
      isShowTop: true,
      initType: false, //初始化状态值 防止初始化多次
      qaGagType: "tips" ////tips: 禁言提示,noTips: 禁言不提示 可以发送 别人看不到
    };
  },
  created() {
    let _this = this;
    $subscriber.subscribe("webinarInfo", data => {
      this.webinarInfo = data;
    });
    $subscriber.subscribe("userInfo", data => {
      this.userInfo = data;
      if (!this.initType) {
        this.init();
      }
    });
    $subscriber.subscribe("onQaTop", data => {
      _this.interaction.topList = [];
      if (!data.isTop) {
        //如果是取消置顶就清空
        _this.isShowTop = false;
      } else {
        cr.each(_this.interaction.list, item => {
          if (item._id == data.qaId) {
            _this.interaction.topList.push(item);
            _this.isShowTop = true;
          }
        });
      }
    });
    $subscriber.subscribe("onQaNewMsg", data => {
      if (data.refList.length > 0) {
        cr.each(data.refList, list => {
          list.updated_at = moment(new Date(list.updated_at).getTime()).format(
            "HH:mm:ss"
          );
        });
      }
      data.updated_at = moment(new Date(data.updated_at).getTime()).format(
        "HH:mm:ss"
      );
      if (data.isChecked) {
        if (this.userInfo.applicantId != data.from_user.uid) {
          _this.onQA(data);
        }
      } else {
        if (this.userInfo.applicantId != data.from_user.uid) {
          _this.remove(data);
        }
      }
    });
    $subscriber.subscribe("onChatNewMsg", data => {
      data.updated_at = moment(new Date(data.updated_at).getTime()).format(
        "HH:mm:ss"
      );
      _this.onChat(data);
    });
    $subscriber.subscribe("onQaDelete", data => {
      data.updated_at = moment(new Date(data.updated_at).getTime()).format(
        "HH:mm:ss"
      );
      _this.remove(data);
    });
    $subscriber.subscribe("onGag", data => {
      if (_this.qaGagType == "tips") {
        if (data.isGag) {
          if (data.expires) {
            $subscriber.emit("showPopup", {
              message:
                "您已被管理员禁言，将在" +
                moment(new Date(data.expires).getTime()).format("HH:mm:ss") +
                " 解除"
            });
          } else {
            $subscriber.emit("showPopup", {
              message: "您已被管理员禁言"
            });
          }
        } else {
          $subscriber.emit("showPopup", { message: "您已解除禁言" });
        }
      }
    });
    //0: 无需审核, 1: 开启审核, 2: 禁言(单人禁言优先级大于集体禁言)
    $subscriber.subscribe("onAllGagStatus", data => {
      if (_this.qaGagType == "tips") {
        if (data.typeId == "0") {
          $subscriber.emit("showPopup", { message: "已经开启公共问答" });
        } else if (data.typeId == "1") {
          $subscriber.emit("showPopup", { message: "已开启发言审核" });
        } else {
          $subscriber.emit("showPopup", { message: "已开启全体禁言" });
        }
      }
    });
    ////tips: 禁言提示,noTips: 禁言不提示 可以发送 别人看不到
    $subscriber.subscribe("onAllGagType", data => {
      this.qaGagType = data.qaGagType;
    });
  },
  methods: {
    init() {
      this.initType = true;
      this.interaction.list = [];
      this.mine.list = [];
      this.conversation.list = [];
      //预览页面不请求qa接口
      if (window.location.href.indexOf("isSetting") == -1) {
        this.loadInteractions();
        this.loadMines();
        this.loadConversations();
      }
    },
    changeStatus() {
      this.status = !this.status;
    },
    changeDiscussType(type) {
      this.type = type;
      if (type == "1") {
        this.interaction.unReadCount = "0";
      } else if (type == "2") {
        this.mine.unReadCount = "0";
      } else {
        this.conversation.unReadCount = "0";
      }
      setTimeout(() => {
        $(".discuss-content").animate(
          { scrollTop: $(".discuss-content").prop("scrollHeight") },
          0
        );
      }, 100);
    },
    //加载互动问答
    loadInteractions() {
      let self = this;
      self.interaction.topList = [];
      webinarService
        .getQas({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.interaction.pageSize,
          updated_at: this.interaction.firstUpdatedAt,
          sort: "updated_at",
          order: "desc",
          uncheckuser: this.userInfo.id
        })
        .then(data => {
          cr.each(data.docs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            cr.each(item.refList, list => {
              list.updated_at = moment(
                new Date(list.updated_at).getTime()
              ).format("HH:mm:ss");
            });
            if (item.refList.length > 1) {
              let ar = [];
              ar.push(item.refList[item.refList.length - 1]);
              item.refList = ar;
            }
            // 管理员角色,发的消息是http://或https://开头的,转成链接
            if (
              item.from_user.role === "2" &&
              (item.content.trim().indexOf("http://") === 0 ||
                item.content.trim().indexOf("https://") === 0)
            ) {
              item.content = `<a href="${item.content.trim()}">${
                item.content
              }</a>`;
            }
            self.interaction.list.unshift(item);
          });
          cr.each(data.topDocs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            cr.each(item.refList, list => {
              list.updated_at = moment(
                new Date(list.updated_at).getTime()
              ).format("HH:mm:ss");
            });
            if (item.refList.length > 1) {
              let ar = [];
              ar.push(item.refList[item.refList.length - 1]);
              item.refList = ar;
            }
            self.interaction.topList.unshift(item);
          });
          if (self.interaction.topList.length > 0) {
            self.topQa = self.interaction.topList[0];
          }
          self.interaction.allTotal = data.total;
          if (data.total >= self.interaction.pageSize) {
            self.interaction.firstUpdatedAt =
              self.interaction.list[0].updated_at;
          } else {
            self.interaction.firstUpdatedAt = undefined;
          }
          setTimeout(() => {
            $(".discuss-content").animate(
              { scrollTop: $(".discuss-content").prop("scrollHeight") },
              0
            );
          }, 100);
        });
    },
    loadMines() {
      webinarService
        .getQas({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.mine.pageSize,
          updated_at: this.mine.firstUpdatedAt,
          user: this.userInfo.id,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data.docs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            cr.each(item.refList, list => {
              list.updated_at = moment(
                new Date(list.updated_at).getTime()
              ).format("HH:mm:ss");
            });
            if (item.refList.length > 1) {
              let ar = [];
              ar.push(item.refList[item.refList.length - 1]);
              item.refList = ar;
            }
            this.mine.list.unshift(item);
          });
          this.mine.allTotal = data.total;
          if (data.total >= this.mine.pageSize) {
            this.mine.firstUpdatedAt = this.interaction.list[0].updated_at;
          } else {
            this.mine.firstUpdatedAt = undefined;
          }
        });
    },
    //加载私聊列表
    loadConversations() {
      webinarService
        .getConversations({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.conversation.pageSize,
          user: this.userInfo.id,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            item.unReadCount = 0;
            this.conversation.list.unshift(item);
          });
        });
    },
    ///获取私聊记录
    loadMessages(option) {
      let self = this;
      self.conversation.currentConversation = [];
      option.unReadCount = 0;
      this.conversation.type = "1";
      this.conversation.currentAdminInfo.adminName = option.admin.userName;
      this.conversation.currentAdminInfo.id = option.admin.uid;
      webinarService
        .getChats({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.conversation.pageSize,
          from_user: option.user.uid,
          to_user: option.admin.uid,
          updated_at: this.conversation.firstUpdatedAt,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data.docs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            } else {
              //              item.from_user.avatar = self.adminImg;
            }
            this.conversation.currentConversation.unshift(item);
          });
          //        if (data.total >= this.conversation.pageSize) {
          //        let time=data.updated_at
          //          this.conversation.firstUpdatedAt(this.conversation.updatedAt().format('yyyy-MM-dd hh:mm:ss'));
          //        } else {
          //          this.conversation.firstUpdatedAt(undefined);
          //        }
        });
    },
    //私聊详情回到详情列表
    backConversation() {
      this.conversation.type = "0";
      this.conversation.currentAdminInfo.adminName = "";
      this.conversation.currentAdminInfo.id = "";
      this.conversation.currentConversation = [];
    },
    get() {
      $("body");
    },
    emoji() {
      this.$refs.emoji.$emit("showEmoji");
    },
    selectFile() {
      this.$refs.localImage.click();
    },
    fileChange(e) {
      var _this = this;
      var files = e.target.files;
      if (files && files.length > 0) {
        var file = files[0];
        var fileType = file.type.toString();
        if (
          file.size > 10000 * 1024 ||
          (file.type.indexOf("png") < 0 &&
            file.type.indexOf("jpg") < 0 &&
            file.type.indexOf("jpeg") < 0 &&
            file.type.indexOf("gif") < 0)
        ) {
          $subscriber.emit(
            "error",
            "图片不能大于10M,必须是jpg,jpeg,png,gif格式"
          );
          this.$refs.localImage.value = "";
          return;
        }
        webinarService
          .upload({
            file: file
          })
          .subscribe(data => {
            if (data.result == 0) {
              var imgTag =
                '<img class="qa-img" src="' + data.content.newPath + '">';
              _this.submit(imgTag);
            } else {
              $subscriber.emit("error", data.desc);
            }
          });
      }
    },
    submit(imgTag = "") {
      let _this = this;
      //
      //匿名用户是否允许提问
      if (
        this.webinarInfo.unLimit &&
        !this.webinarInfo.isAllowMessage &&
        !this.userInfo.isLogin &&
        (!this.userInfo.isRegistration ||
          (this.userInfo.isRegistration && this.userInfo.isUnLimit))
      ) {
        return $subscriber.emit("error", "很抱歉，匿名用户不允许提问！");
      }
      //匿名用户是否设置用户名
      var temporaryUserName = ck.cookie(
        "temporaryUserName_" + this.webinarInfo.webinarId
      );
      if (
        this.webinarInfo.unLimit &&
        this.webinarInfo.isSetUserName &&
        !temporaryUserName
      ) {
        if (
          !this.userInfo.isLogin &&
          (!this.userInfo.isRegistration ||
            (this.userInfo.isRegistration && this.userInfo.isUnLimit))
        ) {
          return $subscriber.emit("onUserNameShow");
        }
      }
      let data = {
        content: this.content ? this.content.replace(/(\r\n|\n|\r)/gm, "") : ""
      };
      if (imgTag) {
        data.content = imgTag;
      }
      if (!data.content) {
        return $subscriber.emit("error", "请填写内容！");
      }
      if (this.type == "3") {
        if (this.conversation.currentConversation.length == 0) {
          return $subscriber.emit("error", "没有私聊的对象！");
        }
        data.user = this.conversation.currentAdminInfo.id;

        socketModule.emit("onChatSubmit", data);
      } else {
        socketModule.emit("onQaSubmit", data, res => {
          if (res.code && res.code.toString() !== "0") {
            return $subscriber.emit("error", res.msg);
          }
          if (res.from_user.role == "0") {
            res.from_user.avatar = res.from_user.avatar
              ? res.from_user.avatar
              : this.userImg;
          } else {
            res.from_user.avatar = "";
          }
          res.updated_at = moment(new Date(res.updated_at).getTime()).format(
            "HH:mm:ss"
          );
          this.onQA(res);
          this.mine.list.push(res);

          if (this.type !== "2") {
            this.mine.unReadCount = this.mine.unReadCount + 1;
          }
        });
      }
      webinarService
        .liveSendmsg({
          browseInfo: interact.browseInfo,
          sess: this.userInfo.isLogin ? _this.userInfo.session : "",
          tenantId: _this.webinarInfo.tenantId,
          webinarId: _this.webinarInfo.webinarId,
          openId: 0,
          instanceId: _this.webinarInfo.instanceId,
          joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
          globalUserId: ck.cookie("globalUserId")
        })
        .subscribe(() => {});
      this.$refs.emoji.clear();
      setTimeout(() => {
        $(".discuss-content").animate(
          { scrollTop: $(".discuss-content").prop("scrollHeight") },
          800
        );
      }, 100);
    },
    getContent(event) {
      this.content = event;
    },
    replaceColon(text) {
      return replaceColon(text);
    },
    onQA(qa) {
      qa.from_user.avatar =
        qa.from_user.avatar || qa.from_user.role == "2"
          ? qa.from_user.avatar
          : this.userImg;
      if (qa.refList.length > 1) {
        let ar = [];
        ar.push(qa.refList[qa.refList.length - 1]);
        qa.refList = ar;
      }
      // 管理员角色,发的消息是http://或https://开头的,转成链接
      if (
        qa.from_user.role === "2" &&
        (qa.content.trim().indexOf("http://") === 0 ||
          qa.content.trim().indexOf("https://") === 0)
      ) {
        qa.content = `<a href="${qa.content.trim()}">${qa.content}</a>`;
      }
      this.interaction.list.push(qa);
      $subscriber.emit("onQAGet", qa);
      if (this.type != "1") {
        this.interaction.unReadCount = this.interaction.unReadCount + 1;
      }
      if (qa.to_user && qa.to_user.uid == this.userInfo.id) {
        this.mine.list.push(qa);
        if (this.type != "2") {
          this.mine.unReadCount = this.mine.unReadCount + 1;
        }
      }
      if (this.type == "1") {
        setTimeout(() => {
          $(".discuss-content").animate(
            { scrollTop: $(".discuss-content").prop("scrollHeight") },
            500
          );
        }, 0);
      }
    },
    remove(qa) {
      let idex = 0;
      cr.each(this.interaction.list, (item, index) => {
        if (item._id == qa._id) {
          idex = index;
        }
      });
      this.interaction.list.splice(idex, 1);
    },
    onChat(qa) {
      let self = this;
      // role  0 是用户 1好像是组织者  2是管理员
      let adminInfo = qa.from_user.role == "2" ? qa.from_user : qa.to_user;
      if (qa.from_user.role == "0") {
        qa.from_user.avatar = qa.from_user.avatar ? qa.from_user.avatar : "";
      } else {
        qa.from_user.avatar = "";
      }
      if (this.type != "3") {
        this.conversation.unReadCount = this.conversation.unReadCount + 1;
      }
      if (qa.from_user.role == "2") {
        qa.admin = qa.from_user;
        qa.user = qa.to_user;
        let chat = {
          content: qa.content
        };
        qa.chat = chat;
      } else {
        let chat = {
          content: qa.content
        };
        qa.admin = qa.to_user;
        qa.user = qa.from_user;
        qa.chat = chat;
      }
      if (this.conversation.list.length == "0") {
        qa.unReadCount = 1;
        this.conversation.list.unshift(qa);
      } else {
        ///  判断是否存在这个id 如果有那么就添加 因为有不同的角色
        var hasThisNew = false;
        cr.each(this.conversation.list, item => {
          if (item.admin.id == adminInfo.id) {
            hasThisNew = true;
          }
        });
        if (!hasThisNew) {
          qa.unReadCount = 1;
          this.conversation.list.unshift(qa);
        } else {
          cr.each(this.conversation.list, item => {
            if (item.admin.id == adminInfo.id) {
              item.chat.content = qa.content;
            }
            if (
              self.conversation.currentConversation.length == "0" &&
              item.admin.id == adminInfo.id
            ) {
              item.unReadCount += 1;
            }
            if (
              self.conversation.currentConversation.length != "0" &&
              this.conversation.currentConversation[0].admin.id == adminInfo.id
            ) {
              this.conversation.currentConversation.push(qa);
            }
          });
        }
      }
      // this.conversation.currentConversation.push(qa);
    },
    showTop(isShow) {
      this.isShowTop = isShow;
    }
  },
  mounted() {
    let self = this;
    $("#wapinteraction").scroll(function() {
      let scrollTop = this.scrollTop;
      if (scrollTop == "0") {
        if (self.interaction.list.length < self.interaction.allTotal) {
          self.loadInteractions();
        }
      }
    });
    $("#wapmine").scroll(function() {
      let scrollTop = this.scrollTop;
      if (scrollTop == "0") {
        if (self.mine.list.length < self.mine.allTotal) {
          self.loadMines();
        }
      }
    });
    $(".edit-able").keydown(function($event) {
      var keycode = window.event ? $event.keyCode : $event.which;
      var evt = $event || window.event;
      if (keycode == 13 && !evt.ctrlKey) {
        self.submit();
        setTimeout(() => {
          $(".edit-able")
            .children("div")
            .remove();
          $(".edit-able").html(
            $(".edit-able")
              .html()
              .replace(/(\r\n|\n|\r)/gm, "")
          ); //安卓的兼容
        }, 0);
      }
    });
  },

  components: { Emoji }
};
</script>

<style scoped></style>
